import { useContext } from 'react'
import { AuthContext, type AuthContextValue } from './authContextCore'

export const useAuth = () => {
  const context = useContext(AuthContext) 
  if (!context) throw new Error('useAuth must be used within AuthProvider')
  return context
}

export const useOptionalAuth = (): AuthContextValue | { user: null; userProfile: null } => {
  const context = useContext(AuthContext)
  if (!context) return { user: null, userProfile: null }
  return context
}
